<template>
  <div class="border border-solid border-linear-strong">
    <span
      class="bg-base-secondary block"
      :style="{ height: `${height}px`, width: `${normalizedValue}%` }"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ProgressLinear',
  props: {
    value: { type: Number, required: true },
    height: { type: Number, required: false, default: 5 },
  },
  computed: {
    normalizedValue(): number {
      return Math.min(100, Math.max(0, this.value))
    },
  },
})
</script>
